export const PropertyToTitle: Record<string, string> = {
  alternateDescription: 'Alternate Description',
  avCost: 'Average Cost',  // To Double Check
  barcode: 'Barcode',
  multipleBarcodes: 'Additional Barcodes',
  binL: 'Bin Location',
  category: 'Category',
  code: 'Code',
  created: 'Created Date',  // To Double Check
  dep: 'Department',
  depName: 'Department Name',
  desc: 'Description',
  discExempt: 'Discount Exempt',  // To Double Check
  dlvColl: 'DelCol Outstanding',
  excludeSellingValue: 'Exclude Sell Value',
  genCode: 'General Code',
  gp1: 'GP',
  itemDiscount: 'Item Discount %',
  itemOrderPrice: 'Item Order Price',  // To Double Check
  itemOrderQuantity: 'Item Order Quantity',  // To Double Check
  lastMoved: 'Last Moved', // To Double Check
  lastPurchase: 'Date Last Purchased',
  lastSold: 'Date Last Sold',
  lastStockTake: 'Last Stock Take',  // To Double Check
  latestCost: 'Latest Cost',
  stockValue: 'Stock Value',
  lineColourCode: 'Line Colour',
  modified: 'Modified',  // To Double Check
  minOrderLevel: 'Min Order Level',  // To Double Check
  maxDisc: 'Max Discount',  // To Double Check
  maxOrderLevel: 'Max Order Level',  // To Double Check
  multipleSuppliers: 'Other Suppliers',  // To Double Check
  nominalGP: 'Nominal GP',
  noDecimal: 'No Decimal',  // To Double Check
  onHand: 'On Hand',
  onHoldCode: 'On Hold Code',
  ordLvl: 'Order Level',
  // orderQuantity: 'Order Quantity',
  orderQty: 'Order Quantity',
  packSize: 'Pack Size',
  prvSellingPri: 'Prev Sell Price',
  prvSellingPriDate: 'Prev Sell Price Date',
  purchaseOrder: 'Purchase Orders',
  recommendedGP: 'Recommended GP',
  regularSuppCode: 'Supplier',
  reportItemCode: 'Report Item Code',  // To Double Check
  reportItemFactor: 'Report Item Factor',  // To Double Check
  salesOrder: 'Sales Order',  // To Double Check
  sellIntoNegative: 'Selling Into Negative',  // To Double Check
  sellUnderCost: 'Selling Under Cost',  // To Double Check
  stockId: 'Stock ID',  // To Double Check
  subDep: 'Sub Department',
  subDepName: 'Sub Department Name',
  suppCode: 'Supplier Stock Code',
  suppUsedLast1: 'Supplier Used Last 1',  // To Double Check
  suppUsedLast2: 'Supplier Used Last 2',  // To Double Check
  suppUsedLast3: 'Supplier Used Last 3',  // To Double Check
  suppUsedLast4: 'Supplier Used Last 4',  // To Double Check
  suppUsedLast5: 'Supplier Used Last 5',  // To Double Check
  suppUsedLastDate1: 'GRV Date',
  suppUsedLastDate2: 'Prev GRV Date',
  suppUsedLastDate3: 'Supplier Used Last Date 3', // To Double Check
  suppUsedLastDate4: 'Supplier Used Last Date 4', // To Double Check
  suppUsedLastDate5: 'Supplier Used Last Date 5', // To Double Check
  suppUsedLastPrice1: 'Supplier Used Last Price 1',  // To Double Check
  suppUsedLastPrice2: 'Supplier Used Last Price 2',  // To Double Check
  suppUsedLastPrice3: 'Supplier Used Last Price 3',  // To Double Check
  suppUsedLastPrice4: 'Supplier Used Last Price 4',  // To Double Check
  suppUsedLastPrice5: 'Supplier Used Last Price 5',  // To Double Check
  sellPriExcl1: 'Price (excl)',
  sellPriIncl1: 'Retail Price',
  sellPrice2: 'Price 2 (excl)',
  sellPriceIncluding2: 'Retail Price 2',
  sellPrice3: 'Price 3 (excl)',
  sellPriceIncluding3: 'Retail Price 3',
  sellPrice4: 'Price 4 (excl)',
  sellPriceIncluding4: 'Retail Price 4',
  sellPrice5: 'Price 5 (excl)',
  sellPriceIncluding5: 'Retail Price 5',
  sellPrice6: 'Price 6 (excl)',
  sellPriceIncluding6: 'Retail Price 6',
  sellPrice7: 'Price 7 (excl)',
  sellPriceIncluding7: 'Retail Price 7',
  sellPrice8: 'Price 8 (excl)',
  sellPriceIncluding8: 'Retail Price 8',
  sellPrice9: 'Price 9 (excl)',
  sellPriceIncluding9: 'Retail Price 9',
  sellPrice10: 'Price 10 (excl)',
  sellPriceIncluding10: 'Retail Price 10',
  unitsYear: 'Units 12 Months',
  unitsMonthAvg: 'Monthly Avg',
  vatR: 'VAT Rate',  // To Double Check
  web: 'Web',  // To Double Check
  user: 'User',  // To Double Check
  ['_tags']: 'Tags',
};
